import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-86">
    <BrowserRouter data-id="element-87">
      <App data-id="element-88" />
    </BrowserRouter>
  </React.StrictMode>);